<template>
    <div
      class="flex flex-col w-full sm:w-6/12 lg:w-4/12 p-4"
      :class="{ 'opacity-50': dragging }"
      @dragover.prevent
      @drop.stop.prevent="onDrop">
        <div class="flex flex-col h-full bg-light-grey rounded p-8 min-h-40">
        <div class="flex items-start">
            <div class="flex justify-between items-center w-full">
                <div class="flex items-start font-bold mr-4 text-sm">
                    <span class="pr-1">{{ index + 1 }}.</span>
                    <span>{{ service.name }}</span>
                    <span class="ml-4 text-xs text-muted opacity-75">{{ service.required ?
            'Объязателен' : '' }}</span>
                </div>
                <span
                  class="sort-drag-handle text-muted ml-3"
                  draggable="true"
                  title="Перетащить услугу"
                  @click.stop
                  @dragstart.stop="onDragStart"
                  @dragend.stop="onDragEnd">
                  <span v-for="dot in 6" :key="dot" class="sort-drag-dot"></span>
                </span>
            </div>
        </div>
        <span class="truncate w-full max-w-md  mt-4 h-full">{{ service.description  }}</span>
        <div class="flex justify-between flex-grow flex-wrap h-full">
            <div class="flex items-center text-sm font-bold text-primary">
            {{ service.price }} &#8381;</div>
            <div class="flex items-center justify-end space-x-4">
              <ButtonBorderless
                v-if="service.archive"
                theme="green"
                @click.native="() => $emit('activate', service.id)">
                Активировать
              </ButtonBorderless>
              <ButtonBorderless
                v-else
                theme="red"
                @click.native="() => $emit('deactivate', service.id)">
                Деактивировать
              </ButtonBorderless>
              <ButtonBorderless
                theme="blue"
                @click.native="() => $eventBus.$emit('service-edit', service.id)">
                Редактировать
              </ButtonBorderless>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import ButtonBorderless from '@/components/ButtonBorderless.vue';

export default {
  components: {
    ButtonBorderless,
  },
  props: {
    service: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onDragStart(e) {
      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(this.service.id));
      }
      this.$emit('drag-start', this.service.id);
    },
    onDragEnd() {
      this.$emit('drag-end');
    },
    onDrop(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      this.$emit('drop-sort', {
        id: this.service.id,
        after: e.clientX > rect.left + (rect.width / 2),
      });
    },
  },
};
</script>

<style scoped>
.sort-drag-handle {
  display: grid;
  grid-template-columns: repeat(2, 3px);
  grid-auto-rows: 3px;
  gap: 3px;
  align-content: center;
  justify-content: center;
  width: 20px;
  min-width: 20px;
  height: 28px;
  cursor: grab;
  user-select: none;
}

.sort-drag-handle:active {
  cursor: grabbing;
}

.sort-drag-dot {
  width: 3px;
  height: 3px;
  border-radius: 9999px;
  background: currentColor;
}
</style>
